import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function subscribeToPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications not supported');
    return false;
  }

  try {
    // Register service worker
    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    // Get VAPID public key
    const { data } = await axios.get(`${API_URL}/api/push/vapid-key`);
    const publicKey = data.publicKey;

    if (!publicKey) {
      console.warn('VAPID key not available');
      return false;
    }

    // Convert VAPID key
    const applicationServerKey = urlBase64ToUint8Array(publicKey);

    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    });

    // Send subscription to backend
    await axios.post(
      `${API_URL}/api/push/subscribe`,
      { subscription: subscription.toJSON() },
      { withCredentials: true }
    );

    return true;
  } catch (err) {
    console.error('Push subscription error:', err);
    return false;
  }
}

export async function unsubscribeFromPushNotifications() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
    }
    await axios.post(`${API_URL}/api/push/unsubscribe`, {}, { withCredentials: true });
    return true;
  } catch (err) {
    console.error('Push unsubscribe error:', err);
    return false;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
